var _circle, _circle2, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2962,
    cy: 26,
    r: 26,
    fill: "#D3CDFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2962,
    cy: 26.1047,
    r: 14.8571,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.7099,
    cy: 29.1785,
    rx: 1.02463,
    ry: 1.53694,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.907,
    cy: 29.1785,
    rx: 1.02463,
    ry: 1.53694,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8252 22.8797H11.7674C13.201 16.1726 19.1613 11.1431 26.2963 11.1431C33.4313 11.1431 39.3916 16.1726 40.8252 22.8797Z",
    fill: "#9888FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8578 21.4741H30.5027C30.1253 19.7097 28.5573 18.3867 26.6803 18.3867C24.8032 18.3867 23.2352 19.7097 22.8578 21.4741Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6823 29.0592L14.3306 22.8799H11.8009C11.2082 23.5429 11.4749 27.2757 11.6823 29.0592Z",
    fill: "#292929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9101 29.0592L38.2618 22.8799H40.7915C41.3842 23.5429 41.1175 27.2757 40.9101 29.0592Z",
    fill: "#292929"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9529,
    cy: 32.4361,
    r: 1.28079,
    fill: "#F09387"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile13);
export default __webpack_public_path__ + "static/media/img_profile_13.f8f803e344e9b86b358dbd8f14e01fce.svg";
export { ForwardRef as ReactComponent };